import { render, staticRenderFns } from "./groups-skeleton.vue?vue&type=template&id=36ef62f6&scoped=true&"
import script from "./groups-skeleton.vue?vue&type=script&lang=js&"
export * from "./groups-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./groups-skeleton.vue?vue&type=style&index=0&id=36ef62f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ef62f6",
  null
  
)

export default component.exports